import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPaymentItem.Delete.IRequest;
type Response = Api.Finance.ContractRefundPaymentItem.Delete.IResponse;
type Headers = Api.Finance.ContractRefundPaymentItem.Delete.IHeaders;
const url = '/api/Finance/ContractRefundPaymentItem/DeleteByContractRefundId/:contractRefundId';
export default async function deleteContractRefundPaymentItemsByContractRefundId(params: {
  contractRefundId: number;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
